import { Component } from "@angular/core";

@Component({
    selector: "web-time-line-shimmer",
    templateUrl: "./time-line-shimmer.component.html",
    styleUrls: ["./time-line-shimmer.component.scss"],
})
export class TimeLineShimmerComponent {
    constructor() {}
}
